// eslint-disable-next-line @fx-ui/jdy-design/import-path-restricted
import { LocaleRecord } from '~/interfaces';
import { LOCALE_KEY } from '@fx-ui/intl';
import ZH_CN from '@fx-ui/fine-design/lib/locale/zh_CN';
import ZH_TW from '@fx-ui/fine-design/lib/locale/zh_TW';
import EN_US from '@fx-ui/fine-design/lib/locale/en_US';
import JA_JP from '@fx-ui/fine-design/lib/locale/ja_JP';
import VI_VN from '@fx-ui/fine-design/lib/locale/vi_VN';
import KO_KR from '@fx-ui/fine-design/lib/locale/ko_KR';
import TH_TH from '@fx-ui/fine-design/lib/locale/th_TH';
import RU_RU from '@fx-ui/fine-design/lib/locale/ru_RU';
import FR_FR from '@fx-ui/fine-design/lib/locale/fr_FR';
import ES_ES from '@fx-ui/fine-design/lib/locale/es_ES';
import ID_ID from '@fx-ui/fine-design/lib/locale/id_ID';
import DE_DE from '@fx-ui/fine-design/lib/locale/de_DE';
import PT_PT from '@fx-ui/fine-design/lib/locale/pt_PT';
import KM_KH from '@fx-ui/fine-design/lib/locale/km_KH';
import LO_LA from '@fx-ui/fine-design/lib/locale/lo_LA';
import HI_IN from '@fx-ui/fine-design/lib/locale/hi_IN';
import BN_BD from '@fx-ui/fine-design/lib/locale/bn_BD';
import TA_IN from '@fx-ui/fine-design/lib/locale/ta_IN';
import UZ_UZ from '@fx-ui/fine-design/lib/locale/uz_UZ';
import MN_MN from '@fx-ui/fine-design/lib/locale/mn_MN';
import IT_IT from '@fx-ui/fine-design/lib/locale/it_IT';
import NL_NL from '@fx-ui/fine-design/lib/locale/nl_NL';
import PL_PL from '@fx-ui/fine-design/lib/locale/pl_PL';
import HU_HU from '@fx-ui/fine-design/lib/locale/hu_HU';
import PT_BR from '@fx-ui/fine-design/lib/locale/pt_BR';

const FINE_DESIGN_LOCALE: LocaleRecord<typeof ZH_CN> = {
    [LOCALE_KEY.ZH_CN]: ZH_CN,
    [LOCALE_KEY.ZH_TW]: ZH_TW,
    [LOCALE_KEY.EN_US]: EN_US,
    [LOCALE_KEY.JA_JP]: JA_JP,
    [LOCALE_KEY.VI_VN]: VI_VN,
    [LOCALE_KEY.RU_RU]: RU_RU,
    [LOCALE_KEY.FR_FR]: FR_FR,
    [LOCALE_KEY.ES_ES]: ES_ES,
    [LOCALE_KEY.TH_TH]: TH_TH,
    [LOCALE_KEY.ID_ID]: ID_ID,
    [LOCALE_KEY.KO_KR]: KO_KR,
    [LOCALE_KEY.DE_DE]: DE_DE,
    [LOCALE_KEY.PT_PT]: PT_PT,
    [LOCALE_KEY.KM_KH]: KM_KH,
    [LOCALE_KEY.LO_LA]: LO_LA,
    [LOCALE_KEY.HI_IN]: HI_IN,
    [LOCALE_KEY.BN_BD]: BN_BD,
    [LOCALE_KEY.TA_IN]: TA_IN,
    [LOCALE_KEY.UZ_UZ]: UZ_UZ,
    [LOCALE_KEY.MN_MN]: MN_MN,
    [LOCALE_KEY.IT_IT]: IT_IT,
    [LOCALE_KEY.NL_NL]: NL_NL,
    [LOCALE_KEY.PL_PL]: PL_PL,
    [LOCALE_KEY.HU_HU]: HU_HU,
    [LOCALE_KEY.PT_BR]: PT_BR
};

export default FINE_DESIGN_LOCALE;
